import React from 'react';
import EventCardSmall, { EventCardSmallProps } from "components/partials/parts/event-card-small"
import IntroHeadline from "components/partials/parts/intro-headline";
import { IntroHeadlineProps } from "types/intro-headline-props";

export type EventCardsGridProps = {
    patternClass?: string;
    intro?: IntroHeadlineProps;
    cards?: EventCardSmallProps[];
};

const EventCardsGrid: React.FC<EventCardsGridProps> = ({ patternClass = 'bg-brand-orange', intro, cards }) => {
    return (
        <div className={`pattern pattern--pad pattern--has-bgcolor ${patternClass} pattern--event-cards-grid`}>
            <div className="container">
                {intro && <IntroHeadline {...intro} />}

                <div className="grid-container grid-container--3up">
                    {cards && cards.map((card, i) => (
                        <EventCardSmall key={i} {...card} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default EventCardsGrid;